import { Field } from "components/dynamic/DynamicForm";
import { TFunction } from "i18next";

export const documentsSchema = (
  t: TFunction<"translation", undefined>,
  isViewMode: boolean
): Field[] => [
  {
    name: "logo",
    label: t("company.fields.logo"),
    type: "upload",
    disabled: isViewMode,
    multiple: false,
    required: true,
    accept: "image/*",
  },
  {
    name: "organizationChartImage",
    label: t("company.fields.organizationChartImage"),
    type: "upload",
    disabled: isViewMode,
    multiple: true,
    required: true,
    accept: "image/*,application/pdf",
  },
  {
    name: "documents.declaration",
    label: t("company.fields.declaration"),
    type: "upload",
    disabled: isViewMode,
    multiple: true,
    required: true,
    accept: "image/*,application/pdf,.doc,.docx,.xls,.xlsx",
  },
  {
    name: "documents.lastInsuranceList",
    label: t("company.fields.lastInsuranceList"),
    type: "upload",
    disabled: isViewMode,
    required: true,
    accept: "image/*,application/pdf,.doc,.docx,.xls,.xlsx",
  },
  {
    name: "documents.patentLicense",
    label: t("company.fields.patentLicense"),
    type: "upload",
    disabled: isViewMode,
    accept: "image/*,application/pdf,.doc,.docx,.xls,.xlsx",
  },
  {
    name: "documents.brandRegistrationLicense",
    label: t("company.fields.brandRegistrationLicense"),
    type: "upload",
    disabled: isViewMode,
    accept: "image/*,application/pdf,.doc,.docx,.xls,.xlsx",
  },
  {
    name: "documents.others",
    label: t("company.fields.others"),
    type: "upload",
    disabled: isViewMode,
    multiple: true,
    accept: "image/*,application/pdf,.doc,.docx,.xls,.xlsx",
  },
];
